import React, { useEffect } from "react";
import Header from "../landingsections/Header";
import FloatIcons from "../landingsections/FloatIcons";
import Footer from "../landingsections/Footer";
import AOS from "aos";
import "aos/dist/aos.css";

const PrivacyPolicy = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="page-wrapper">

      <Header />

      <div className="container py-5">
        <div className="text-center mb-5" data-aos="fade-up">
          <h1 className="fw-bold">Privacy Policy</h1>
          <p className="text-muted">
            Your privacy is important to us at AZSM Enterprises
          </p>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-up">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Information We Collect</h4>
            <ul className="text-muted">
              <li>
                We collect personal information such as your name, email address,
                phone number, and payment details when you book our travel services.
              </li>
              <li>
                We also collect information about your travel preferences and
                interests to personalize our services.
              </li>
            </ul>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-right">
          <div className="card-body">
            <h4 className="fw-bold mb-3">How We Use Your Information</h4>
            <ul className="text-muted">
              <li>
                To process bookings, payments, and provide travel services.
              </li>
              <li>
                To communicate booking updates, promotions, and newsletters.
              </li>
              <li>
                To improve services and personalize your experience.
              </li>
            </ul>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-left">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Sharing Your Information</h4>
            <ul className="text-muted">
              <li>
                Shared with airlines, hotels, and tour operators for bookings.
              </li>
              <li>
                Shared with business partners for promotional communications.
              </li>
              <li>
                We do NOT sell or rent your personal data.
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6" data-aos="zoom-in">
            <div className="card shadow-sm border-0 mb-4 h-100">
              <div className="card-body">
                <h4 className="fw-bold mb-3">Security</h4>
                <ul className="text-muted">
                  <li>
                    We take strong measures to protect your personal data.
                  </li>
                  <li>
                    Payment data is secured using encryption technologies.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-6" data-aos="zoom-in">
            <div className="card shadow-sm border-0 mb-4 h-100">
              <div className="card-body">
                <h4 className="fw-bold mb-3">Cookies</h4>
                <ul className="text-muted">
                  <li>
                    Cookies help us improve your browsing experience.
                  </li>
                  <li>
                    Disabling cookies may limit some features.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4 mt-3" data-aos="fade-up">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Third-Party Links</h4>
            <ul className="text-muted">
              <li>
                Our site may contain links to external websites.
              </li>
              <li>
                We are not responsible for their content or privacy practices.
              </li>
            </ul>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-up">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Changes to This Policy</h4>
            <ul className="text-muted">
              <li>
                We may update this policy anytime.
              </li>
              <li>
                Updates will be posted on this page.
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-5" data-aos="fade-up">
          <p className="fw-semibold">
            By using our services, you agree to this Privacy Policy.
          </p>
        </div>
      </div>

      <FloatIcons />
      <Footer />

    </div>
  );
};

export default PrivacyPolicy;